import { createSelector } from 'reselect';

import { HomographyCamera } from '../actions/homographyActions';
import { CalibrationType } from '../interfaces/homography';
import { HomographyState } from '../reducers/homography/homographyState';
import { selectHomography } from './stateSelectors';

// TODO: considering refactoring this into individual selectors. This might be an anti pattern.
export const selectCalibrationPoints = (camera: HomographyCamera, calibrationType: CalibrationType) =>
  createSelector(selectHomography, (Homography) => {
    switch (calibrationType) {
      case CalibrationType.LPR:
        return getLPRPoints(camera, Homography);
      case CalibrationType.NIGHTLPR:
        return getNightLPRPoints(camera, Homography);
      case CalibrationType.MAP:
        return getMapPoints(camera, Homography);
      default:
        return [];
    }
  });

export const selectIsSumbitting = createSelector(selectHomography, (Homography) => Homography.isSubmitting);

export const selectCalculatedHomography = (type: CalibrationType) =>
  createSelector(selectHomography, (Homography) => {
    switch (type) {
      case CalibrationType.LPR:
        return Homography.lPRPairs.calculatedHomography;
      case CalibrationType.NIGHTLPR:
        return Homography.nightLPRPairs.calculatedHomography;
      case CalibrationType.MAP:
        return Homography.mapPairs.calculatedHomography;
      default:
        return null;
    }
  });

export const selectIsModified = (type: CalibrationType) =>
  createSelector(selectHomography, (Homography) => {
    switch (type) {
      case CalibrationType.LPR:
        return Homography.lPRPairs.modified;
      case CalibrationType.NIGHTLPR:
        return Homography.nightLPRPairs.modified;
      case CalibrationType.MAP:
        return Homography.mapPairs.modified;
      default:
        return null;
    }
  });

export const selectActiveMapMarkers = createSelector(selectHomography, (homography) => homography.mapPairs.activeMarkers);

const getLPRPoints = (cameraType: HomographyCamera, Homography: HomographyState) => {
  switch (cameraType) {
    case HomographyCamera.CONTEXT:
      return Homography.lPRPairs.imagePairs.imageOne.points;
    case HomographyCamera.LPR:
      return Homography.lPRPairs.imagePairs.imageTwo.points;
  }
};

const getNightLPRPoints = (cameraType: HomographyCamera, Homography: HomographyState) => {
  switch (cameraType) {
    case HomographyCamera.CONTEXT:
      return Homography.nightLPRPairs.imagePairs.imageOne.points;
    case HomographyCamera.LPR:
      return Homography.nightLPRPairs.imagePairs.imageTwo.points;
  }
};

const getMapPoints = (cameraType: HomographyCamera, Homography: HomographyState) => {
  switch (cameraType) {
    case HomographyCamera.CONTEXT:
      return Homography.mapPairs.imagePairs.imageOne.points;
    case HomographyCamera.MAP:
      return Homography.mapPairs.imagePairs.imageTwo.points;
  }
};
